/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import { useTranslation } from 'react-i18next';
import Lottie from "lottie-react";
import successfuly from "../Lottie/Successfullysecounde.json";
import ImageLoad from '../ImageLoad';

const BookingDetails = ({ Data }) => {

    const { t } = useTranslation();

    const { setActivePage } = useContext(MyContext);

    const navigate = useNavigate();

    const HandleViewBooking = () => {
        sessionStorage.removeItem("Bookid");
        setActivePage(1);
        navigate("/");
    };

    return (
        <div>
            <div className="h-[100%] overflow-hidden scroll-container">
                <div className="">
                    <Lottie
                        className="w-[160px] mx-auto"
                        animationData={successfuly}
                        loop={true}
                    />
                    <h1 className='text-center font-[500] text-[20px]'>{t("You have successfully booking")}</h1>
                    <p className='text-center font-[500] text-[16px] text-gray-600'>{Data?.appoint_data.book_date}</p>
                    <ImageLoad src={Data?.qrcode} CustomeStyle={"mx-auto object-contain"} alt={"qrcode"} />
                </div>
                <div className="border-[2px] border-[#8080803b] p-[10px] rounded-[10px] mb-[15px]">
                    <div className="flex items-center justify-between border-b-[1px] border-[#8080803b] pb-[5px]">
                        <div className="">
                            <h1 className='font-bold text-[18px]'>{t("Booking Fee")}</h1>
                        </div>
                        <h1 className='font-bold text-[18px]'>$ {Data?.appoint_data.tot_price}</h1>
                    </div>
                    <div className="mt-[5px] flex items-center gap-[20px] whitespace-nowrap">
                        <h1 className='font-[500] text-[16px]'>Clinic name :-</h1>
                        <h1 className='text-[17px] font-[500] overflow-hidden overflow-ellipsis'>{Data?.appoint_data.hospital_name}</h1>
                    </div>
                    <div className="mt-[5px] flex items-center gap-[20px] whitespace-nowrap">
                        <h1 className='font-[500] text-[16px]'>{t("Department name")} :-</h1>
                        <h1 className='text-[17px] font-[500] overflow-hidden overflow-ellipsis'>{Data?.appoint_data.department_name}</h1>
                    </div>
                    <div className="mt-[5px] flex items-center gap-[20px] whitespace-nowrap">
                        <h1 className='font-[500] text-[16px]'>{t("SubType")} :-</h1>
                        <h1 className='text-[17px] font-[500] overflow-hidden overflow-ellipsis'>{Data?.appoint_data.sub_title}</h1>
                    </div>
                </div>
                <div className="pt-[15px] border-t-[3px] border-[#8080803b] px-[5px]">
                    <h1 className='font-bold text-[18px]'>{t("Transaction Dtails")}</h1>
                    <div className="flex items-center gap-[20px] justify-between py-[3px]">
                        <h1 className='font-[500] text-[17px]'>{t("Doctor Consultation Charge")}</h1>
                        <h1 className='font-[500] text-[17px]'>$ {Data?.appoint_data.show_type_price}</h1>
                    </div>
                    <div className="flex items-center gap-[20px] justify-between py-[3px]">
                        <h1 className='font-[500] text-[17px]'>{t("Doctor Commission")}</h1>
                        <h1 className='font-[500] text-[17px]'>$ {Data?.appoint_data.doctor_commission}</h1>
                    </div>
                    {Data?.appoint_data.payment_name && <div className="flex items-center gap-[20px] justify-between py-[3px]">
                        <h1 className='font-[500] text-[17px]'>{t("Payment Type")}</h1>
                        <h1 className='font-[500] text-[17px]'>({Data?.appoint_data.payment_name}) : $ {Data?.appoint_data.tot_price}</h1>
                    </div>}
                    {Data?.appoint_data.wallet_amount !== 0 && <div className="flex items-center gap-[20px] justify-between py-[3px]">
                        <h1 className='font-[500] text-[17px]'>{t("Wallet Amount")}</h1>
                        <h1 className='font-[500] text-[17px]'>${Data?.appoint_data.wallet_amount}</h1>
                    </div>}
                    <div className="flex items-center gap-[20px] justify-between mb-[5px] py-[3px]">
                        <h1 className='font-[500] text-[17px]'>{t("Service Fee & Tax")}</h1>
                        <h1 className='font-[500] text-[17px]'>$ {Data?.appoint_data.site_commisiion}</h1>
                    </div>
                    {Data?.appoint_data.coupon_amount !== 0 && <div className="flex items-center gap-[20px] justify-between mb-[5px] py-[3px]">
                        <h1 className='font-[500] text-[17px]'>{t("Coupon Amount")}</h1>
                        <h1 className='font-[500] text-[17px] text-green-500'>$ -{Data?.appoint_data.coupon_amount}</h1>
                    </div>}
                    <div className="flex items-center gap-[20px] justify-between pt-[5px] border-t-[2px] border-dashed border-[#8080803b]">
                        <h1 className='font-[500] text-[17px]'>{t("Total Price")}</h1>
                        <h1 className='font-[500] text-[17px]'>$ {Data?.appoint_data.tot_price}</h1>
                    </div>
                </div>
                <button onClick={HandleViewBooking} className='payment-btn mt-[10px]'>{t("View Booking")}</button>
            </div>
        </div>
    )
}

export default BookingDetails
/* jshint ignore:end */